var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgM01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6435 6.27739L10.446 2.12239C9.64349 1.47739 8.34599 1.47739 7.55099 2.11489L2.35349 6.27739C1.76849 6.74239 1.39349 7.72489 1.52099 8.45989L2.51849 14.4299C2.69849 15.4949 3.71849 16.3574 4.79849 16.3574H13.1985C14.271 16.3574 15.2985 15.4874 15.4785 14.4299L16.476 8.45989C16.596 7.72489 16.221 6.74239 15.6435 6.27739ZM9.53099 12.8999C9.38099 13.0499 9.19349 13.1249 8.99849 13.1249C8.80349 13.1249 8.61599 13.0499 8.46599 12.9074C8.17349 12.6149 8.17349 12.1424 8.46599 11.8499C8.75849 11.5574 9.23849 11.5574 9.53099 11.8499C9.82349 12.1349 9.82349 12.6074 9.53099 12.8999ZM10.9935 11.1749C10.881 11.2874 10.7385 11.3474 10.5885 11.3474C10.446 11.3474 10.311 11.2949 10.1985 11.1899C9.47099 10.4924 8.52599 10.4924 7.79099 11.1899C7.56599 11.4074 7.21349 11.3999 6.99599 11.1749C6.77849 10.9499 6.78599 10.5974 7.01099 10.3799C8.17349 9.26239 9.80099 9.26239 10.971 10.3799C11.2035 10.5899 11.211 10.9499 10.9935 11.1749ZM12.5835 9.58489C12.471 9.69739 12.3285 9.75739 12.1785 9.75739C12.036 9.75739 11.8935 9.70489 11.7885 9.59989C11.436 9.25489 11.0385 8.97739 10.6185 8.77489C9.56849 8.27239 8.42099 8.27239 7.37849 8.77489C6.95849 8.97739 6.56849 9.25489 6.20849 9.59989C5.99099 9.81739 5.63099 9.81739 5.41349 9.59239C5.19599 9.36739 5.20349 9.01489 5.42099 8.79739C5.86349 8.36239 6.35849 8.01739 6.89099 7.76239C8.24849 7.10989 9.74849 7.10989 11.0985 7.76239C11.631 8.01739 12.126 8.36239 12.5685 8.79739C12.7935 9.00739 12.801 9.36739 12.5835 9.58489Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM01);
export default __webpack_public_path__ + "static/media/m_01.6e7c8d924bd58d5612685f5f408ecba9.svg";
export { ForwardRef as ReactComponent };